export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10486.5580936d.jpg";